
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M5 27.19V2.81h15l5 5v19.38H5z"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M14.67 5.81c-2.75-.65-2 5.59 1.13 9.31 3.94 4.65 7.32 4.07 7.32 2.9 0-2.27-5.13-1.51-9.08.23-2.79 1.24-8.89 3.77-6.7 5.59 3.07 2.54 9.73-17.46 7.33-18.03z"}})])])
          )
        }
      }
    